import React from 'react';
import { TextVariant } from '@naf/text';
import useSelector from '@redux/typedHooks';
import { MembershipBenefitReference } from '@appTypes/membershipBenefitReferenceType';
import { BenefitItemRecordType } from '@appTypes/BenefitsOverviewType';
import * as S from './Styles';
import { ResultPage } from './ResultPage';

type ProcessedPageData = {
  data: MembershipBenefitReference[];
  meta: { isLoading: boolean };
};

const Header = () => (
  <S.HeaderWrapper>
    <S.Header>
      <S.Title>Faste rabatter</S.Title>
    </S.Header>
  </S.HeaderWrapper>
);

const getProcessedBenefits = (pages: BenefitItemRecordType): ProcessedPageData => {
  const hasPages = Object.keys(pages).length > 0;
  const isLoading = !hasPages || Object.values(pages).some((page) => page.meta.isLoading);

  const combinedData = Object.values(pages).flatMap((page) =>
    (page.data ?? []).filter(
      (item) => !item.campaignDetails?.endDate || new Date(item.campaignDetails.endDate) < new Date(),
    ),
  );

  return {
    data: combinedData,
    meta: { isLoading },
  };
};

export const FixedResults = () => {
  const { items: pages, query } = useSelector((state) => state.membershipBenefitSearch);
  const singleBenefitPage = getProcessedBenefits(pages);
  const { data, meta } = singleBenefitPage;
  const { isLoading } = meta;
  const hasResults = data.length > 0;
  const trimmedQuery = query.trim();
  const emptyMessage = trimmedQuery ? `Ingen resultater funnet for "${trimmedQuery}".` : 'Ingen resultater funnet.';

  if (hasResults) {
    return (
      <>
        <Header />
        <S.SubGrid>
          <ResultPage page={singleBenefitPage} />
        </S.SubGrid>
      </>
    );
  }

  if (isLoading) {
    return (
      <>
        <Header />
        <S.SubGrid key="emptyResult">
          <ResultPage page={{ data: [], meta: { isLoading: true } }} />
        </S.SubGrid>
      </>
    );
  }

  return (
    <S.SubGrid>
      <S.EmptyState>
        <S.EmptyStateText tag="p" variant={TextVariant.BodyText}>
          {emptyMessage}
        </S.EmptyStateText>
      </S.EmptyState>
    </S.SubGrid>
  );
};
